import React from "react";
import "./LoadingSpinner.css";

export default function LoadingSpinner({ isVisible }) {
  if (!isVisible) return null;

  return (
    <div className="loading-spinner-overlay">
      <div className="loading-spinner-container">
        <div className="loading-spinner"></div>
        <p className="loading-spinner-text">Loading...</p>
      </div>
    </div>
  );
}
